import { useState } from 'react'
import { SystemSS } from '../../../components/SystemSS'
import { FullScreenModal } from '../../../utility/FullScreenModal'

export const FacilitiesSalvage = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
        console.log('clickd')
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-salvage-fr.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        <span className='text-pborange'>Obtenez automatiquement les trésors</span> cachés dans une
                        région nautique donnée en envoyant des groupes de Repêcheuses. Le temps nécessaire et les objets
                        reçus dépendent de la région et de l'approche choisie par l'équipe de Repêcheuses envoyée.
                    </p>{' '}
                    <br />
                    <p className='mt-4'>
                        Votre équipe cherchera automatiquement les objets à mesure que le temps passe, et ce même si
                        vous ne finissez pas un niveau ou que vous ne progressez pas dans l'histoire, alors veillez à
                        envoyer ces groupes en mission ! Ce service est décidément bien pratique !
                    </p>
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'salvage',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description='Les objets trouvés dépendent du niveau de la Pêcheuse ! Le temps nécessaire pour trouver des objets diminuera à mesure que vous renforcerez le groupe de Repêcheuses à coups de BOR (la devise).'
                    />{' '}
                </div>
            </section>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={1}
            />
        </>
    )
}
